import { render, staticRenderFns } from "./FundIndustry.vue?vue&type=template&id=2d5959aa&scoped=true"
import script from "./FundIndustry.vue?vue&type=script&lang=js"
export * from "./FundIndustry.vue?vue&type=script&lang=js"
import style0 from "./FundIndustry.vue?vue&type=style&index=0&id=2d5959aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5959aa",
  null
  
)

export default component.exports